export default "__VITE_ASSET__CMLMm6So__"